import { render, staticRenderFns } from "./c-property-inventory.vue?vue&type=template&id=d6ab51b0&"
import script from "./c-property-inventory.vue?vue&type=script&lang=js&"
export * from "./c-property-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports